import { isAxiosError } from "axios";

import type { ApiErrorBody } from "@/types/api";

export interface ParsedApiError {
  code: string;
  details: Record<string, unknown>;
  requestId?: string;
  status?: number;
}

/**
 * Xatodan backend konvertini ajratadi. Tarmoq xatosi — `NETWORK_ERROR`,
 * konvertsiz javob — `UNKNOWN_ERROR`: UI har doim kodga tayanadi.
 */
export function parseApiError(error: unknown): ParsedApiError {
  if (!isAxiosError(error)) return { code: "UNKNOWN_ERROR", details: {} };
  if (!error.response) return { code: "NETWORK_ERROR", details: {} };

  const body = error.response.data as Partial<ApiErrorBody> | undefined;
  const code = body?.error?.code;
  return {
    code: typeof code === "string" && code ? code : "UNKNOWN_ERROR",
    details: body?.error?.details ?? {},
    requestId: body?.requestId,
    status: error.response.status,
  };
}

/** Access token eskirgan — jimgina yangilanadi. Qolgan 401 lar — qayta kirish. */
export const REFRESHABLE_CODES = new Set(["TOKEN_EXPIRED", "TOKEN_STALE", "NO_TOKEN"]);

type Translate = (key: string, values?: Record<string, unknown>) => string;
type HasKey = (key: string) => boolean;

/** Lug'atdan xabar: `errors.<CODE>`, bo'lmasa umumiy xabar. */
export function errorMessage(error: unknown, t: Translate, has: HasKey): string {
  const { code, details } = parseApiError(error);
  const key = `errors.${code}`;
  return has(key) ? t(key, details) : t("errors.UNKNOWN_ERROR");
}
